<template>
	<div :class="classes">
		<span v-if="matchingLevelIcon" class="job-vita--grid-area-section-item--matching-icon">
			<Icon :icon="matchingLevelIcon.icon" :color="matchingLevelIcon.color"/>
		</span>
		<div>
			<span v-if="item.title" v-html="item.title"/>
			<!-- 2025-01: not needed right now -->
			<!--			<span v-if="item.needsUpgrade" class="job-vita&#45;&#45;grid-area-section-item-title-needs-upgrade">-->
			<!--				<Button-->
			<!--					text="Details"-->
			<!--					secondary-->
			<!--					smaller-->
			<!--					@click="showUpgradePopUp = true"-->
			<!--				/>-->
			<!--			</span>-->
		</div>
		<PredefinedValue
			v-if="item.predefinedValue"
			:predefined-value="item.predefinedValue"
		/>
		<ul v-if="item.extras.length > 0" class="job-vita--grid-area-section-item-extras">
			<li
				v-for="extra in item.extras"
				:key="extra.id"
			>
				<span v-if="extra.label">{{ extra.label }}:</span>
				<span>{{ extra.value }}</span>
			</li>
		</ul>
		<div v-if="item.subItems.length > 0" class="pl-4">
			<application-job-vita-grid-area-section-item
				v-for="subItem in item.subItems"
				:key="subItem.id"
				:item="subItem"
				:job-profile-id="jobProfileId"
				:pseudonym-id="pseudonymId"
				@upgrade="$emit('upgrade')"
			/>
		</div>
		<UpgradePopUp
			v-if="showUpgradePopUp"
			:job-profile-id="jobProfileId"
			:pseudonym-id="pseudonymId"
			@upgrade="onUpgrade"
			@hidden="showUpgradePopUp = false"
		/>
	</div>
</template>

<script>
import Button from "@/vue/common/Button";
import UpgradePopUp from "@/vue/permission/UpgradePopUp";
import PredefinedValue from "@/vue/application/job/vita/grid/PredefinedValue";
import Icon from "@/vue/icon/Icon.vue";

export default {

	components: {
		Icon,
		PredefinedValue,
		Button,
		UpgradePopUp,
	},

	props: {
		jobProfileId: {
			type: String,
			required: true,
		},
		pseudonymId: {
			type: String,
			required: false,
		},
		item: {
			type: Object,
			required: true,
		}
	},

	data ()
	{
		return {
			showUpgradePopUp: false,
		};
	},

	computed: {
		classes ()
		{
			let classes = ['job-vita--grid-area-section-item'];

			if (this.item.matchingLevel)
			{
				classes.push('job-vita--grid-area-section-item-matching-level-' + this.item.matchingLevel);
			}

			return classes;
		},
		matchingLevelIcon ()
		{
			if (!this.item.matchingLevel)
			{
				return undefined;
			}

			if (this.item.matchingLevel === 'full')
			{
				return {
					icon: 'checkmark',
					color: 'green'
				};
			}

			if (this.item.matchingLevel === 'partial')
			{
				return {
					icon: 'tilde',
					color: 'gold'
				};
			}

			return {
				icon: 'close',
				color: 'red'
			};
		},
	},

	methods: {
		onUpgrade ()
		{
			this.showUpgradePopUp = false;

			this.$emit('upgrade');
		}
	}
}
</script>
